import { Icon } from "@brexhq/metal-icon";
import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import breakpoints from "@brexhq/shared/styles/breakpoints";
import { mobile } from "@brexhq/shared/types/SpacingScale";

import { AccordionTitle } from "./Typography";

const paddingVariable = "--accordion-v-padding";

export const hideSummaryMarkerStyles = css`
  list-style: none;

  &::marker {
    display: none;
  }

  &::-webkit-details-marker {
    display: none;
  }
`;

const BaseAccordion = styled.details`
  ${paddingVariable}: ${mobile.med}px;
  ${breakpoints.SML} {
    ${paddingVariable}: ${mobile.xsml}px;
  }
  padding-block: var(${paddingVariable});

  ${({ theme }) => theme.borders.defaultBorder.top}
  ${({ theme }) => theme.borders.defaultBorder.bottom}

  & + & {
    border-top: none;
  }
`;
const AccordionContent = styled.div`
  /* inherited from BaseAccordion */
  padding-top: var(${paddingVariable});
`;
const AccordionHeader = styled(AccordionTitle)`
  ${hideSummaryMarkerStyles}

  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;
const AccordionHeaderCaret = styled.span`
  flex: 0 0 auto;
  margin-block: auto;
  transition: transform ${({ theme }) => theme.animations.duration.slow}
    ${({ theme }) => theme.animations.timingFunction};
  details[open] & {
    transform: rotate(180deg);
  }
`;

const Caret = styled(Icon)`
  --size: 32px;
  ${breakpoints.SML} {
    --size: 16px;
  }

  width: var(--size);
  height: var(--size);
`;

export const Accordion = ({
  header,
  children,
}: {
  children: React.ReactNode;
  header: React.ReactNode;
}) => {
  const { colors } = useTheme();
  return (
    <BaseAccordion>
      <AccordionHeader as="summary">
        <span>{header}</span>
        <AccordionHeaderCaret>
          <Caret
            name="chevronDown"
            size={undefined as any}
            color={colors.content.tertiary}
          />
        </AccordionHeaderCaret>
      </AccordionHeader>
      <AccordionContent>{children}</AccordionContent>
    </BaseAccordion>
  );
};
